import React, { useState } from "react";
import { Check } from "lucide-react";
import { contact } from "../mock";
import Reveal from "./Reveal";
import { useToast } from "../hooks/use-toast";

export default function ContactForm({ innerRef }) {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", phone: "", business: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.business) {
      toast({ title: "Completa todos los campos", description: "Necesitamos tus datos para contactarte." });
      return;
    }
    setSubmitting(true);
    // Mocked submission — stored locally only (frontend-only version)
    setTimeout(() => {
      const leads = JSON.parse(localStorage.getItem("dtv_leads") || "[]");
      leads.push({ ...form, at: new Date().toISOString() });
      localStorage.setItem("dtv_leads", JSON.stringify(leads));
      setSubmitting(false);
      setForm({ name: "", phone: "", business: "" });
      toast({
        title: "¡Solicitud enviada!",
        description: "Un asesor te contactará por WhatsApp en las próximas 24 horas.",
      });
    }, 700);
  };

  return (
    <section ref={innerRef} className="relative border-t border-white/[0.06] py-24">
      <div className="mx-auto grid max-w-6xl items-start gap-12 px-6 lg:grid-cols-2">
        {/* Left copy */}
        <Reveal>
          <p className="mb-4 text-[13px] font-medium uppercase tracking-[0.2em] text-violet-400">
            {contact.eyebrow}
          </p>
          <h2 className="font-display text-[32px] font-bold leading-tight text-white sm:text-[42px]">
            {contact.heading}
          </h2>
          <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-white/55">
            {contact.desc}
          </p>
          <ul className="mt-8 space-y-4">
            {contact.bullets.map((b, i) => (
              <li key={i} className="flex items-center gap-3 text-[15px] text-white/80">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-violet-500/15 text-violet-300">
                  <Check className="h-4 w-4" />
                </span>
                {b}
              </li>
            ))}
          </ul>
        </Reveal>

        {/* Right form */}
        <Reveal delay={120}>
          <form
            onSubmit={handleSubmit}
            className="rounded-3xl border border-white/[0.08] bg-white/[0.025] p-7 backdrop-blur-sm"
          >
            <div className="space-y-5">
              {[
                { name: "name", label: contact.fields.name, type: "text", ph: "Ej. María Pérez" },
                { name: "phone", label: contact.fields.phone, type: "tel", ph: "+52 55 1234 5678" },
                { name: "business", label: contact.fields.business, type: "text", ph: "Ej. Glow Spa" },
              ].map((field) => (
                <div key={field.name}>
                  <label className="mb-2 block text-[13px] font-medium text-white/70">
                    {field.label}
                  </label>
                  <input
                    name={field.name}
                    type={field.type}
                    value={form[field.name]}
                    onChange={handleChange}
                    placeholder={field.ph}
                    className="w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-[15px] text-white placeholder:text-white/30 outline-none transition-colors focus:border-violet-400/60 focus:bg-white/[0.05]"
                  />
                </div>
              ))}
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="btn-lavender mt-7 w-full rounded-full px-6 py-3.5 text-[15px] font-semibold disabled:opacity-70"
            >
              {submitting ? "Enviando..." : contact.submit}
            </button>
            <p className="mt-4 text-center text-[12px] leading-relaxed text-white/40">
              {contact.disclaimer}
            </p>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
